"use client";

import { useState } from "react";

import { BotonInstalar, type EstadoInstalacion } from "@/components/boton-instalar";

/**
 * **El botón primero; las instrucciones solo si el navegador no deja instalar por código.**
 *
 * Es la diferencia entre "instálala" y "haz tú estos cinco pasos". Donde se puede, se hace por la
 * persona. Donde no —hoy solo iPhone, porque Apple no expone ninguna API para esto— se le explica, y se
 * le explica **solo a quien lo necesita**: a nadie más le aparecen esas instrucciones.
 */
export function Contenido() {
  const [estado, setEstado] = useState<EstadoInstalacion>("cargando");

  return (
    <div className="flex flex-col gap-5">
      <BotonInstalar onEstado={setEstado} />

      {estado === "ios" ? (
        <div className="flex flex-col gap-2 rounded-3xl border border-border bg-muted p-5">
          <span className="font-semibold">Para instalarla en tu iPhone</span>
          <span className="text-sm text-muted-foreground leading-relaxed">
            Apple no permite que las apps se instalen solas, así que hay que hacer dos toques: el botón de{" "}
            <strong>compartir</strong> (el cuadrito con la flecha hacia arriba, abajo en el centro) y después{" "}
            <strong>Agregar a inicio</strong>.
          </span>
        </div>
      ) : null}

      {estado === "sin-soporte" ? (
        <div className="flex flex-col gap-2 rounded-3xl border border-border bg-muted p-5">
          <span className="font-semibold">Instálala desde el menú de tu navegador</span>
          <span className="text-sm text-muted-foreground leading-relaxed">
            Busca <strong>Instalar</strong> o <strong>Agregar a la pantalla de inicio</strong> en el menú (los tres
            puntos, arriba a la derecha). Si no te aparece, prueba con Chrome.
          </span>
        </div>
      ) : null}

      {estado === "cargando" ? <div className="h-14" aria-busy="true" /> : null}
    </div>
  );
}
